import { render, staticRenderFns } from "./EventsTemplateDetails.vue?vue&type=template&id=5c0db996&scoped=true&"
import script from "./EventsTemplateDetails.vue?vue&type=script&lang=ts&"
export * from "./EventsTemplateDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0db996",
  null
  
)

export default component.exports